import styled from "styled-components";

export const ShortListBarWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 2rem;
    align-items: center;
    background-color: ${(props) => props.theme.LayoutBodyBackground};
    z-index: 100;

    .shortlist-count {
        border-left: 1px solid ${(props) => props.theme.DarkerBorderColor};
        padding-left: 0.5rem;
        margin-left: 0.5rem;
        font-size: 0.9rem;
    }

    .send-shortlist {
        cursor: pointer;
        font-size: 1.5rem;
        opacity: 0.8;
        line-height: 1;

        &:hover {
            opacity: 1;
        }

        &.disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }

    @media (max-width: 640px) {
        justify-content: center;

        .send-shortlist {
            font-size: 1.25rem;
        }
    }
`;

export const SendShortlistDrawerWrapper = styled.div`
    padding-top: 2rem;

    .button-wrapper {
        padding: 1rem 0;
    }

    .models-group-container {
        margin: 2rem 0 1rem 0;

        .models-group-name {
            text-transform: capitalize;
            font-size: 1.35rem;
            margin-bottom: 0;
            font-weight: ${(props) => props.theme.FontWeightBold};
            padding: 0 1rem 0.5rem 0;
            font-family: "Inter Tight", sans-serif;
        }

        .models-container {
            display: block;

            .model-cover {
                padding-top: 0.5rem;
                padding-bottom: 1rem;
                padding-left: 0;
                position: relative;
                display: flex;
                justify-content: flex-start;
                align-items: center;

                &.model-cover-active {
                    background-color: #f5f5f5;
                }

                .model-cover-img {
                    display: block;
                    position: relative;

                    .model-cover-backgroundimg-container {
                        width: 3rem;
                        height: 3rem;
                        background-size: cover;
                        background-position: center center;
                        background-repeat: no-repeat;
                        transition: all 0.2s linear;
                        z-index: 10;
                    }
                }

                .model-name-and-features {
                    padding-left: 1rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-start;
                    width: 100%;
                    height: ${(props) => props.$itemHeight};

                    .model-name {
                        margin-bottom: 0.5rem;
                        padding-right: 4rem;
                        h3 {
                            font-size: 1rem;
                            font-weight: ${(props) => props.theme.FontWeightBold};
                            line-height: 1.25em;
                            text-transform: uppercase;
                            margin: 0;
                            cursor: pointer;
                        }
                    }

                    .model-in-group-name {
                        font-size: 0.75rem;
                        line-height: 1.25em;
                        padding-right: 4rem;
                    }
                }
            }
        }
    }
`;

export const SendShortlistLoadingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    height: 80vh;

    .sending-icon {
        font-size: 4rem;
    }

    .sending-text {
        font-size: ${(props) => props.theme.FontSizeMedium};
        font-weight: bold;
    }
`;
